// extracted by mini-css-extract-plugin
module.exports = {"mailingScreen":"mailingScreen__3omclOZiiLlNb","block":"block__yOgiNb2MUv+pB"};